'use strict';

/**
 * @ngdoc overview
 * @name courseApp
 * @description
 * # courseApp
 *
 * Main module of the application.
 */
angular
    .module('courseApp')
    .config(function ($routeProvider, $resourceProvider, momentPickerProvider) {
        $routeProvider
            .when('/', {
                controller: 'HomeController',
                templateUrl: 'views/home.html',
                controllerAs: 'homeCtrl',
                name: 'Home',
                publicAccess: true
            })
            .when('/course', {
                templateUrl: 'views/course.html',
                controller: 'CourseController',
                controllerAs: 'course',
                name: 'Lehrgänge'
            })
            .when('/attendee', {
                templateUrl: 'views/attendee.html',
                controller: 'AttendeeController',
                controllerAs: 'attendeeC',
                name: 'Teilnehmer/Ausbilder'
            })
            .when('/hotel', {
                templateUrl: 'views/hotel.html',
                controller: 'HotelController',
                controllerAs: 'hotel',
                name: 'Hotels'
            })
            .when('/checkin', {
                templateUrl: 'views/checkin.html',
                controller: 'CheckinController',
                controllerAs: 'checkinC',
                name: 'Check-In'
            })
            .when('/group', {
                templateUrl: 'views/group.html',
                controller: 'GroupController',
                controllerAs: 'groupC',
                name: 'Gruppen'
            })
            .when('/check', {
                templateUrl: 'views/check.html',
                controller: 'CheckController',
                controllerAs: 'check',
                name: 'Checks'
            })
            .when('/logout', {
                // A template or templateUrl is required by AngularJS, even if your controller always redirects.
                template: '',
                controller: function (Auth) {
                    Auth.logout();
                },
                controllerAs: 'logout'
            })
            .otherwise({
                redirectTo: '/'
            });
        // Don't strip trailing slashes from calculated URLs
        $resourceProvider.defaults.stripTrailingSlashes = false;
        momentPickerProvider.options({
            format: 'L LTS',
            startView: 'month'
        });
    })
    .run(function ($rootScope, $location, $route, Auth) {
        var routesOpenToPublic = [];
        angular.forEach($route.routes, function (route, path) {
            // push route onto routesOpenToPublic if it has a truthy publicAccess value
            if (route.publicAccess) {
                routesOpenToPublic.push(path);
            }
            // route.publicAccess && (routesOpenToPublic.push(path));
        });

        var routeChange = $rootScope.$on('$routeChangeStart', function () {
            var closedToPublic = (routesOpenToPublic.indexOf($location.path()) === -1);
            if (closedToPublic && !Auth.isLoggedIn()) {
                $location.path('/login');
            }
        });
        // clean up listener when directive's scope is destroyed
        $rootScope.$on('$destroy', routeChange);
    });
